import React from 'react';
import _ from 'lodash';
import { Select } from 'antd';

function SelectMultiple({
  id,
  name,
  value,
  placeholderText,
  onChange,
  options,
  label,
  required,
  className,
  disabled,
  error
}) {
  const { Option } = Select;
  return (
    <div className={`${className} text-sm tracking-tight space-y-1`}>
      <span className="selectLabel text-sm">{label}{required && <span className="text-red-500 ml-1">*</span>}</span>
      <Select
        mode="multiple"
        id={id}
        name={name}
        value={value}
        onChange={(newValue) => {
          onChange(newValue);
        }}
        disabled={disabled}
        placeholder={placeholderText}
        className="disabled:bg-gray-100 disabled:text-gray-400 h-11 placeholder-gray-400 text-gray-900 text-base rounded-md w-full appearance-none focus:ring-1 focus:ring-accent focus:border-accent outline-none focus:outline-none transition ease-in-out duration-500"
      >
        {_.map(options, (option) => (
          <Option
            key={option.key}
            value={option.value}
            disabled={option.disabled}
          >
            {option.text}
          </Option>
        ))}
      </Select>
      {error && <div className="text-sm ml-2 font-light text-red-500">{error}</div>}
    </div>
  );
}

export default SelectMultiple;
